interface ContructorParams {
	id?: number
	name: string
	city: string
	address: string
	sellerId?: number
	fiscalName?: string | null
	fiscalCountry?: "ES" | "EN" | "MX" | "CA" | "US" | null
	fiscalAddress?: string | null
	paymentDays?: number | null
	nif?: string | null
	iban?: string | null
	feePercent?: number | null
}

export class SellerOffice {
	public id?: number
	public name: string
	public city: string
	public address: string
	public sellerId?: number
	public fiscalName?: string | null
	public fiscalCountry?: "ES" | "EN" | "MX" | "CA" | "US" | null
	public fiscalAddress?: string | null
	public paymentDays?: number | null
	public nif?: string | null
	public iban?: string | null
	public feePercent?: number | null

	constructor(params: ContructorParams) {
		this.id = params.id
		this.name = params.name
		this.city = params.city
		this.address = params.address
		this.sellerId = params.sellerId
		this.fiscalName = params.fiscalName
		this.fiscalCountry = params.fiscalCountry
		this.fiscalAddress = params.fiscalAddress
		this.paymentDays = params.paymentDays
		this.nif = params.nif
		this.iban = params.iban
		this.feePercent = params.feePercent
	}
}
